import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";

import App from "./App";
import { MantineProvider } from "@mantine/core";
import { mantineTheme } from "./mantine.theme";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <MantineProvider theme={mantineTheme}>
        <App />
      </MantineProvider>
    </BrowserRouter>
  </StrictMode>,
);
